import React from "react";
import "./payment-method.css";
import { Link } from "react-router-dom";
import checkIcon from "images/check-icon.png";
import visaIcon from "images/visa-icon.png";
import mastercardIcon from "images/mastercard-icon.png";
import americanExpressIcon from "images/american-express-icon.png";
import jcbIcon from "images/jcb-icon.png";
import discoverIcon from "images/discover-icon.png";
import dinersClubIcon from "images/diners-club-icon.png";
import defaultCardIcon from "images/default-card-icon.png";

import MediaQuery from "react-responsive";
function PaymentMethod(props) {
  const paymentMethod = props.paymentMethod;

  const expiration = paymentMethod.exp_month + "/" + paymentMethod.exp_year;

  const payment = {
    icon: null,
    name: paymentMethod.brand,
    ending: paymentMethod.last4,
    expiration: expiration,
    cssClass: "col-md-2 col-sm-2 col-lg-2",
    selectButton: null,
    status: "Verified"
  };

  const defaultViewState = {
    showActions: true,
    showSelect: false,
    className: "col-md-6"
  };

  const viewState = Object.assign({}, defaultViewState, props.viewState);

  let deletePaymentMethodClick = paymentMethod => {
    props.handleShow("DeletePaymentMethod", true, {
      currentPaymentMethod: paymentMethod,
      currentPlan: props.currentPlan,
      removePaymentMethod: props.removePaymentMethod
    });
  };

  if (paymentMethod.object === "card") {
    switch (paymentMethod.brand) {
      case "Visa":
        payment.icon = visaIcon;
        break;
      case "MasterCard":
        payment.icon = mastercardIcon;
        break;
      case "American Express":
        payment.icon = americanExpressIcon;
        break;
      case "JCB":
        payment.icon = jcbIcon;
        break;
      case "Discover":
        payment.icon = discoverIcon;
        break;
      case "Diners Club":
        payment.icon = dinersClubIcon;
        break;
      default:
        payment.icon = defaultCardIcon;
    }
  } else if (paymentMethod.object === "bank_account" || !paymentMethod.object) {
    payment.icon = checkIcon;
    payment.name = paymentMethod.bank_name;
    payment.ending = paymentMethod.last4;
    payment.expiration = undefined;
    payment.status =
      paymentMethod.ach_verified === "true" ? "Verified" : "Unverified";
    payment.cssClass =
      paymentMethod.ach_verified === "true"
        ? "col-md-2 col-sm-2"
        : "col-md-2 col-sm-2 pending";
  }

  if (
    props.component === "MakePayment" &&
    (payment.status === "Unverified" ||
      paymentMethod.monthlyPayment === "false")
  ) {
    viewState.disabledPayment = true;
  }

  if (paymentMethod.monthlyPayment === "false") {
    viewState.disabledPayment = true;
  }

  const actionButtons = (
    <div className="col-md-1 col-sm-1 actions">
      <Link
        className="delete-link"
        to={"/payment-methods/delete/" + paymentMethod.id}
        onClick={() => deletePaymentMethodClick(paymentMethod)}
      >
        Delete
      </Link>
    </div>
  );

  if (viewState.showSelect) {
    payment.selectButton = (
      <div className="payment-method col-md-1 select-payment">
        <input
          type="radio"
          disabled={viewState.disabledPayment}
          onChange={() => props.setPaymentMethod(paymentMethod)}
          checked={
            props.selectedPaymentMethod &&
            props.selectedPaymentMethod.id === paymentMethod.id &&
            !props.emptyStepOption
          }
        />
      </div>
    );

    viewState.className = "col-md-3 col-sm-3";
  }

  return (
    <div className="payment-method rounded-box">
      <div className="row">
        {viewState.showSelect ? payment.selectButton : null}
        <MediaQuery minWidth={481}>
          <div className="icon col-md-8 col-sm-8 col-lg-8">
            <span className="col-md-2 col-sm-2">
               <img
                 src={payment.icon}
                 className="icon"
                 alt="payment method"
               />
            </span>
            <span className="col-md-7 col-sm-7">
              {payment.name} ending in {paymentMethod.last4}
            </span>
            <span className={payment.cssClass}>
              {payment.expiration || payment.status}
            </span>
          </div>
        </MediaQuery>
        <MediaQuery maxWidth={480}>
          <div className="text-left">
            <img
              src={payment.icon}
              className="icon col-md-2 col-sm-2"
              alt="payment method"
            />
            <div className="col-sm-12">{payment.name}</div>
            <div className="col-sm-12">ending in: {paymentMethod.last4}</div>
            <div className={payment.cssClass}>
              {payment.expiration || payment.status}
            </div>
          </div>
        </MediaQuery>
        {viewState.showActions ? actionButtons : null}
      </div>
    </div>
  );
}

export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/home/components/payment-method.js